import React from 'react';
import { F } from '@/utils/intl';
import { getContactCustomer, getContactName, getCustomerLabel } from '@/utils/contacts';
import type { PartnerDuplicate } from './usePartnerDuplicateContact';

/** "Email already belongs to X (Customer)." — or "…, a contact of another customer" when X is the customer. */
const DuplicateElsewhereText: React.FC<{ duplicate: NonNullable<PartnerDuplicate> }> = ({ duplicate }) => {
  const name = getContactName(duplicate.contact);
  const customer = getCustomerLabel(getContactCustomer(duplicate.contact));
  return customer && customer !== name ? (
    <F
      id="component.contacts.duplicateElsewhere"
      defaultMessage="{field, select, email {Email} other {Phone}} already belongs to {name} ({customer})."
      values={{ field: duplicate.field, name: <b>{name}</b>, customer }}
    />
  ) : (
    <F
      id="component.contacts.duplicateOtherCustomer"
      defaultMessage="{field, select, email {Email} other {Phone}} already belongs to {name}, a contact of another customer."
      values={{ field: duplicate.field, name: <b>{name}</b> }}
    />
  );
};

export default React.memo(DuplicateElsewhereText);
